import { getCurrentUser } from './utils';

export async function handleBestandImport({ entiteit, year, jrnid, accid, fileName, xmlContent }) {
  const user_id = await getCurrentUser();
  const response = await fetch('/bestand/handleImport', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entiteit, year, jrnid, accid, fileName, xmlContent, user_id, office: '' }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Import mislukt (${response.status})`);
  }
  var responseData = await response.json();
  console.log(responseData);
  return responseData;
}

export async function fetchBestandStatus() {
  const response = await fetch('/bestand/fetchUpdates');
  if (response.ok) return response.json();
  return [];
}

export async function resetBestandStatus() {
  await fetch('/bestand/resetStatus');
}
